import React from 'react';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { BrowserRouter as NavLink } from "react-router-dom";
import ListIcon from '@material-ui/icons/List';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import actionsImg from '../assets/images/actionsImg.png';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';

const styles = theme => ({
    root: { display: 'flex', flexWrap: 'wrap', transformOrigin: 'center bottom' },
    paper: { marginRight: theme.spacing(2), backgroundColor: "#fff" },
    actionFontSize: { fontSize: "14px", },
    menuItemConBtn: { padding: 0 },
    mailBtn: { color: "#515974", textDecoration: "none", display: "flex", fontSize: 14, alignSelf: "center" },
    ActnBtn: {
        color: "#6d6f6f", backgroundColor: "#eef2f4", height: 30, width: 30, minWidth: 0,
        borderRadius: "50%", padding: 0, fontWeight: "400", lineHeight: "1.42857143",
        '&:hover': { color: "#6d6f6f", backgroundColor: "#f8f8f8" }
    },
    btnIcon: { fontSize: 18, marginRight: 20, color: "rgba(0, 0, 0, 0.38)" },
    PopperWrap: {
        zIndex: 10001,
        boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
        '& ul': {
            padding: 0
        }
    },
    deleteTxt: { color: "#b10222", fontSize: "14px !important" },
    liCommon: { borderBottom: "1px solid #dadfe0", padding: "12px 15px", "&:last-child": { borderBottom: "none" } }
});
class ActionButtonForProvider extends React.Component {
    state = { anchorEl: null, open: false, scroll: 'body' };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget, open: true });
    };
    handleEditUser = (name, clone) => {
let newversion=true;
if((this.props.status === "Approved"&& this.props.versionnumber === this.props.versionlength)||clone==='clone'){
newversion=false;
}
        this.handleClose();
        this.props.handleEditUser(this.props.resourceid, name, this.props.versionnumber, clone,newversion);
    };
    handleDeleteUser = () => {
        this.handleClose();
        this.props.handleDeleteUser(this.props.resourceid, this.props.versionnumber);
    };
    handleClose = () => {
        this.setState({ anchorEl: null, open: false });
    };
    handlepreview = () => {
        this.handleClose();
        this.props.handlepreview(this.props.resourceid, this.props.versionnumber);
    };

    render() {
        let name;
        if (this.props.name === "afb") {
            name = this.props.name.toUpperCase();
        }
        else {
            name = this.props.name[0].toUpperCase() + this.props.name.slice(1);
        }
        const COLOR = "rgb(177, 2, 34)";
        const greenColor='green';
        const { anchorEl } = this.state;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Button aria-owns={anchorEl ? 'simple-menu' : undefined} aria-haspopup="true" onClick={this.handleClick} className={classes.ActnBtn} >
                    <img src={actionsImg} width="31px" />
                </Button>
                <Popper className={classes.root + " " + classes.PopperWrap} id="simple-menu" anchorEl={anchorEl} open={this.state.open} onClose={this.handleClose}>
                    <Paper>
                        <ClickAwayListener onClickAway={this.handleClose}>
                            <MenuList autoFocusItem={this.open} id="menu-list-grow" >
                                {(this.props.name === "category") ? <div>
                                    <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handleEditUser}><EditIcon className={classes.btnIcon} /> {'Edit Category'}</MenuItem>
                                    <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handleDeleteUser} style={{ color: "red" }}><DeleteIcon className={classes.btnIcon} style={{ color: "red" }} /> {'Delete Category'}</MenuItem>
                                    <NavLink to={{ pathname: "/TopicsList", search: "?id=" + this.props.resourceid }}>
                                        <MenuItem className={classes.actionFontSize + " " + classes.liCommon} ><ListIcon className={classes.btnIcon} />{'Topics'}</MenuItem>
                                    </NavLink> </div> : ""}
                                {
                                    <div>
                                        {this.props.status === "Approved" ? this.props.versionnumber === this.props.versionlength ?
                                            <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={() => this.handleEditUser(`version-${this.props.versionnumber}`)}><EditIcon className={classes.btnIcon} /> {`Create New Version`}</MenuItem> :
                                            <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={() => this.handleEditUser(`version-${this.props.versionnumber}`)}><VisibilityIcon className={classes.btnIcon} /> {`View Old Version`}</MenuItem>:
                                            <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={() => this.handleEditUser(`revision-${this.props.revison}`)}><EditIcon className={classes.btnIcon} /> {`Edit ${name}`}</MenuItem>}
                                            <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={() => this.handleEditUser(`revision-${this.props.revison}`, 'clone')}><FileCopyIcon className={classes.btnIcon} />Clone</MenuItem>
                                        {(this.props.name !== "meditation")&&
                                        <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handlepreview}><VisibilityIcon className={classes.btnIcon} /> {`${name} Preview`}</MenuItem>}
                                        {this.props.versionnumber===this.props.versionlength&&(this.props.deletevalue!==1)&&<MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handleDeleteUser} style={{ color: COLOR }}><DeleteIcon className={classes.btnIcon}
                                        style={{ color: COLOR }} /> {`Delete ${name}`}</MenuItem>} 
                                        </div> }
                                {(this.props.name === "topic") ? <div>
                                    <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handleEditUser} ><EditIcon className={classes.btnIcon} /> {'Edit Topic'}</MenuItem>
                                    <MenuItem className={classes.actionFontSize + " " + classes.liCommon} onClick={this.handleDeleteUser} style={{ color: COLOR }}><DeleteIcon className={classes.btnIcon} />
                                        {'Delete Topic'}</MenuItem> </div> : ""}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Popper>
            </div>
        );
    }

}

export default (withStyles(styles)((ActionButtonForProvider)));